module.exports = __webpack_public_path__ + "static/media/home_hero.7cdcfddf.webp";